import { render, staticRenderFns } from "./pubdialog.vue?vue&type=template&id=fea89bd8&scoped=true&"
import script from "./pubdialog.vue?vue&type=script&lang=js&"
export * from "./pubdialog.vue?vue&type=script&lang=js&"
import style0 from "./pubdialog.vue?vue&type=style&index=0&id=fea89bd8&scoped=true&lang=less&"
import style1 from "./pubdialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea89bd8",
  null
  
)

export default component.exports